import MoreVertIcon from '@mui/icons-material/MoreVert';
import React, { useState } from "react";
import Rating from '@mui/material/Rating';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import dateFormat from 'dateformat';
import { DeleteForever, Edit, MoreVert } from '@material-ui/icons';
import axios from 'axios';
import { Dropdown } from 'react-bootstrap';
import SecurityHeaders from '../../data/SecurityHeaders';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
const BountyItem = ({ item , reload }) => {
  const [expanded, setExpanded] = useState({});

  const toggleReadMore = (id) => {
    setExpanded((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const shouldShowReadMore = item.bounty_description.length > 20;

  const [open, setOpen] = useState({
    open: false,
    message: '',
  type: ''
  
  });

  const deleteBounty = async (id) => {

    try {
      const data = new FormData();
      data.append('bounty_id', id);
      const res = await axios.post("https://internalapi.skillsuprise.com/delete-bounty.php", data, SecurityHeaders);
      if (res.data.status ==='success') {
    
   reload()
     
        setOpen({open:true,message:res.data.message,type:'success'})
      } else {
      
        setOpen({open:true,message:res.data.message,type:'error'})
      }
    } catch (error) {
      setOpen({open:true,message:error,type:'error'})
 
    }
  };
  const handleClose2 = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(open=>({...open,open:false}));
  };

  return (
<>

<Snackbar open={open.open} onClose={handleClose2} autoHideDuration={4000} >
        <Alert
          
          severity={open.type === 'success' ? 'success' : 'error'}
          onClose={() => {}}
          variant="filled"
               className='col-md-6 col-12'

        >
          {open.message}
        </Alert>
      </Snackbar>
    <div className="col-12 my-4">
      <div
        className="card shadow-sm border-0"
        style={{
          borderRadius: '12px',
          backgroundColor: '#fff',
          padding: '20px',
          transition: 'box-shadow 0.3s ease',
        }}
      >
        {/* Header Section */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0" style={{ fontWeight: '600', color: '#1a1a1a' }}>
            {item.bounty_title}
          </h5>
          <div className="ml ms-2">
              <Dropdown className="options-dropdown ml-4">
                <Dropdown.Toggle className="bg-transparent options p-0 w-fit h-fit border-0">
                  <MoreVert className="text-dark" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item >
                    <Link to={'/update-bug-bounty/'+item.bounty_id}><Edit className="m-1 p-1 w-22" /> Edit Course</Link>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => deleteBounty(item.bounty_id)}>
                    <DeleteForever className="m-1 p-1 w-22" /> Delete Course
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
        </div>

        {/* Category */}
        <div className="mb-3">
          <span
            style={{
              fontSize: '14px',
              color: '#666',
              backgroundColor: '#f1f3f5',
              padding: '4px 10px',
              borderRadius: '12px',
            }}
          >
            Category: {item.category}
          </span>
        </div>

        {/* Payout and Metrics */}
        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
          <div className='d-flex align-items-center'>
            <h6 style={{ fontWeight: '600', color: '#1a1a1a', marginBottom: '4px' }}>
              Payout
            </h6>
            <p className='ms-2' style={{ color: '#2ecc71', fontSize: '16px', fontWeight: '500' }}>
              ${item.payout || '87.00'}
            </p>
          </div>
          <div className='d-flex align-items-center'>
            <h6 style={{ color: '#666', marginBottom: '4px' }}>p1:</h6>
            <p className='ms-2' style={{ color: '#1a1a1a' }}>{item.p1 || '7654'}</p>
          </div>
          <div className='d-flex align-items-center'>
            <h6 style={{ color: '#666', marginBottom: '4px' }}>p2:</h6>
            <p className='ms-2' style={{ color: '#1a1a1a' }}>{item.p2 || '876'}</p>
          </div>
          <div className='d-flex align-items-center' >
            <h6 style={{ color: '#666', marginBottom: '4px' }}>p3:</h6>
            <p className='ms-2' style={{ color: '#1a1a1a' }}>{item.p3 || '87654'}</p>
          </div>
          <div className='d-flex align-items-center'>
            <h6 style={{ color: '#666', marginBottom: '4px' }}>p4:</h6>
            <p className='ms-2' style={{ color: '#1a1a1a' }}>{item.p4 || '786765'}</p>
          </div>
          <span
            className="badge"
            style={{
              backgroundColor: '#e9ecef',
              color: '#2ecc71',
              fontWeight: '500',
              padding: '6px 12px',
              borderRadius: '12px',
            }}
          >
            Active
          </span>
        </div>

        {/* Description */}
        <div className="mb-4">
          <h6 style={{ fontWeight: '600', color: '#1a1a1a', marginBottom: '8px' }}>
            Description:
          </h6>
          <p style={{ color: '#666', lineHeight: '1.6' }}>
            {expanded[item.bounty_id]
              ? item.bounty_description
              : item.bounty_description.substring(0, 350) +
                (shouldShowReadMore ? '...' : '')}
            {shouldShowReadMore && (
              <Link
                onClick={() => toggleReadMore(item.bounty_id)}
                style={{
                  color: '#007bff',
                  cursor: 'pointer',
                  textDecoration: 'none',
                  fontWeight: '500',
                  marginLeft: '8px',
                }}
              >
                {expanded[item.bounty_id] ? 'Read less' : 'Read more'}
              </Link>
            )}
          </p>
        </div>

        {/* Footer Section */}
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div className="d-flex gap-4">
            <div>
              <h6 style={{ color: '#666', marginBottom: '4px' }}>Start date:</h6>
              <p style={{ color: '#1a1a1a' }}>{ dateFormat(item.start_date, "dS mmmm yyyy") || 'TBD'}</p>
            </div>
            <div>
              <h6 style={{ color: '#666', marginBottom: '4px' }}>Tech stack:</h6>
              <p style={{ color: '#1a1a1a' }}>{item.tech_stack || 'TBD'}</p>
            </div>
            <div>
              <h6 style={{ color: '#666', marginBottom: '4px' }}>Deadline:</h6>
              <p style={{ color: '#1a1a1a' }}>{ dateFormat(item.deadline, "dS mmmm yyyy") || 'TBD'}</p>
            </div>
          </div>

          <div className="d-flex align-items-center gap-3">
            <a
              href={item.link || '#'}
              style={{
                color: '#007bff',
                textDecoration: 'none',
                fontWeight: '500',
              }}
            >
              Link
            </a>
            <div className="d-flex align-items-center gap-1">
              <span style={{ color: '#1a1a1a', fontWeight: '500' }}>4.5</span>
              <Rating
                name="half-rating"
                defaultValue={4.5}
                precision={0.5}
                readOnly
                size="small"
              />
            </div>
          </div>
        </div>
        <div>
          
        </div>
      </div>
    </div>
</>
  );
};

export default BountyItem;